import { da } from 'vuetify/locale';
import designerI18n from './designer-i18n.js';

export default {
    welcome: "Velkommen",
    login: "Log ind",
    logout: "Log ud",
    about: "Om",
    dashboard: "Forside",
    products: "Produkter",
    users: "Brugere",
    labels: "Etiketter",
    createUser: "Opret bruger",
    editUser: "Rediger bruger",
    deleteUser: "Slet bruger",
    userList: "Brugerliste",
    productList: "Produktliste",
    createProduct: "Opret produkt",
    editProduct: "Rediger produkt",
    deleteProduct: "Slet produkt",
    labelSettings: "Etiketindstillinger",
    createCategory: "Opret kategori",
    editCategory: "Rediger kategori",
    deleteCategory: "Slet kategori",
    categoryList: "Kategoriliste",
    dragToReorder: "Træk for at arrangere kategorierne anderledes",
    name: "Navn",
    nameFormat: "Navn (Fornavn Efternavn)*",
    email: "Email",
    emailFormat: "Email*",
    role: "Er admin",
    actions: "Handlinger",
    save: "Gem",
    cancel: "Annuller",
    edit: "Rediger",
    delete: "Slet",
    confirmDelete: "Er du sikker?",
    yes: "Ja",
    no: "Nej",
    search: "Søg...",
    itemsPerPageText: 'Elementer pr side:',
    pageText: '{0}-{1} af {2}',
    productName: "Produktnavn*",
    productNumber: "Produktnummer",
    productOnList: "Produktnavn",
    category: "Kategori",
    categoryOnList: "Kategori",
    categories: "Kategorier",
    noCategories: "Ingen kategorier",
    thawingDays: "Optøning (dage)",
    notesHint: "Yderligere information om dette produkt",
    refridgeDays: "Køleskab (dage)",
    threeHoursHint: "Kan produktet holde sig ude i 3 timer?",
    allergens: "Allergener",
    selectAllergens: "Vælg allergener",
    noAllergens: "Ingen allergener",
    notes: "Note",
    daysUntilExpiration: "Dage indtil udløb",
    daysNeededForThawing: "Dage nødvendig for optøning",
    daysInRefrigeration: "Dage i køleskab",
    producedDateLabel: "Produceret dato",
    openedDateLabel: "Åbnet dato",
    createdAt: "Oprettet den",
    updatedAt: "Opdateret den",
    expirationDate: "Udløbsdato",
    openedDate: "Åbnet dato",
    producedDate: "Produceret dato",     
    numLabels: "Antal etiketter",
    quantity: "Antal",
    foodItems: "Produkter",
    printSelected: "Udskriv valgte",
    mandatoryField: "angiver et obligatorisk felt",
    categoryName: "Kategorinavn*",
    description: "Beskrivelse",
    descriptionHint: "Linjeskift med Enter",
    standardCategory: "Standard kategori",
    fieldRequired: "Felt er påkrævet",
    standard: "Standard",
    devices: "Enheder",
    deviceNick: "Enheds kaldenavn",
    deviceID: "Enheds ID",
    confirmDeleteDevice: "Er du sikker på, at du vil slette enheden:",
    userAdministration: "Brugeradministration",
    newPasswordOptional: "Nyt Password (valgfrit)",
    passwordFormat: "Password*",
    password: "Password",
    admin: "Administrator",
    printFooditems: "Udskriv labels",
    fromFooditems: "fra madvarer",
    loadingHomepage: "Indlæser hjemmeside...",
    pleaseLogin: "Log venligst ind for at få adgang til hjemmesiden",
    settings: "Indstillinger",
    displaySettings: "Visningsindstillinger",
    theme: "Tema",
    light: "Lys",
    dark: "Mørk",
    language: "Sprog",  
    selectLanguage: "Vælg sprog",
    finnish: "Finsk",
    danish: "Dansk",
    english: "Engelsk",
    swedish: "Svensk",
    norweigian: "Norsk",
    german: "Tysk",
    japaneese: "Japansk",
    selectedLabel: "Valgt etiket",
    dataManagement: "Data Management",
    importData: "Importér Data",
    exportData: "Eksportér Data",
    importExport: "Import / Eksport",
    exportProducts: "Eksportér Produkter",
    importProducts: "Importér Produkter",
    selectFile: "Vælg Fil",
    upload: "Upload",
    download: "Download",
    dataImportSuccess: "Data importeret succesfuldt",
    dataImportError: "Fejl ved import af data",
    importProductsSubtitle: "Importér produkter fra en xlsx fil.",
    useCategories: "Vis kategorier",
    defaultLabel: "Standard etiket",
    defaultLabelHint: "Vælg den etiket, der skal vælges ved udskrivning af etiketter.",
    noLabelsAvailable: "Ingen etiketter tilgængelige",
    copy: "Kopi",
    useAliasAsTitle: "Brug alias som titel",
    useAliasAsTitleHint: "Bruge 'Alias' feltet i stedet for 'Produktnavn'. Hvis 'Alias' er tomt, bruges 'Produktnavn' som fallback.",
    menus: "Menuer",
    locations: "Lokationer",
    deleteSelected: "Slet valgte",
    confirmDeleteSelected: 'Er du sikker på at du vil slette {count} produkter?',
    create: "Opret",
    createNewCategory: "Opret ny kategori",
    nutritionProfile: "Næringsprofil",
    nutritionProfileHint: "Bruges af næringsindholds-elementet på etiketter.",
    noNutritionProfiles: "Ingen næringsprofiler endnu",
    days: "Dage",
    hours: "Timer",
    alias: "Alias",
    barcode: "Stregkode",

    // Label Designer
    labelDesigner: "Etiketdesigner",
    saveLabel: "Gem etiket",
    refresh: "Opdater",
    selectLabel: "Vælg etiket",
    createNewLabel: "Opret ny etiket",
    labelName: "Etiketnavn",
    width: "Bredde (mm)",
    height: "Højde (mm)",
    titleFont: "Titelskrift (pt)",
    titleX: "Titel X (mm)",
    titleY: "Titel Y (mm)",
    active: "Aktiv",
    addField: "Tilføj felt",
    fieldType: "Felttype",
    labelText: "Felttekst",
    baseDate: "Basisdato",
    offsetField: "Offset-felt",
    databaseField: "Databasefelt",
    xPosition: "X-position (mm)",
    yPosition: "Y-position (mm)",
    fontSize: "Skriftstørrelse (pt)",
    qrSize: "QR-kode størrelse (mm)",
    preview: "Forhåndsvisning",
    sampleItemName: "Eksempel produktnavn",
    size: "Størrelse",
    scale: "Skala",
    fieldsCount: "Felter",
    newLabel: "Ny etiket",
    newField: "Nyt felt",
    labelSaved: "Etiket gemt!",
    loadLabelsFailed: "Kunne ikke indlæse etiketter",
    saveLabelFailed: "Kunne ikke gemme etiket",
    labelPrinting: "Label udskrift",
    productsPerPage: "Varer pr side",
    showAll: "Vis alle",
    selectAtLeastOne: "Vælg venligst mindst én vare.",
    noLabelSelected: "Ingen etiket valgt. Vælg venligst en etiket i indstillinger.",
    labelColor: "Etiketfarve",
    creditZplImage: "ZPL-image plugin udviklet af: ",
    fieldTypePrompt: "Indtastnings Prompt",
    promptDialogTitle: "Indtastning",

    // Label Type
    labelType: "Etikettype",
    labelTypeStandard: "Standard",
    labelTypeFreetext: "Fritekst",
    freetextNotice: "Fritekst-etiketter er blanke felter til fri tekstindtastning på tabletten. Intet produktnavn eller foruddefinerede felter vises.",

    // Logo
    logo: "Logo",
    logoReplace: "Erstat",
    logoUpload: "Upload",
    logoRemove: "Fjern",
    logoNoLogo: "Intet logo uploadet. Tilføj et for at placere det på etiketten.",
    logoUploadTitle: "Upload logo",
    logoSelectFile: "Vælg PNG-billede",
    logoSelectFileHint: "Upload billedet allerede roteret, som du vil have det printet.",
    logoWidthOnLabel: "Bredde på etiket (mm)",
    logoWidthHint: "Højden beregnes automatisk",
    logoPrinterDpi: "Printer DPI",
    logoOriginal: "Original",
    logoTarget: "Mål",
    logoBlackThreshold: "Sort-tærskel",
    logoBlackThresholdHint: "Lavere = kun mørke pixels bliver sorte. Højere = lysere pixels bliver også sorte.",
    logoPreviewOriginal: "Original",
    logoPreviewMono: "Monokrom (som printet)",
    logoApply: "Anvend",
    logoLoaded: "Logo indlæst ({width}×{height}mm). Brug X/Y nedenfor til at placere det på etiketten.",
    logoNotUploaded: "Intet logo uploadet endnu. Gå til Etiketindstillinger → Logo for at uploade et.",
    logoUploaded: "Logo uploadet og konverteret",
    logoUploadFailed: "Kunne ikke uploade logo",
    logoProcessFailed: "Kunne ikke behandle logo",
    logoInvalidDimensions: "Ugyldige dimensioner",
    logoNoFile: "Ingen fil valgt",

    // Field Types (dropdown titles)
    fieldTypeDate: "Dato",
    fieldTypeDatePlus: "Dato + dage",
    fieldTypeDatabase: "Databasefelt",
    fieldTypeQrcode: "QR-kode",
    fieldTypeBarcode: "Stregkode (Code128)",
    fieldTypeLogo: "Logo-billede",
    fieldTypeValueOnly: "Kun værdi (flydende)",
    fieldTypeAllergensText: "Allergentekst",
    fieldTypeStatic: "Statisk tekst",
    fieldTypeDivider: "Skillelinje",

    // Value Only sub-types
    valueType: "Værditype",
    valueTypeDate: "Dato",
    valueTypeDatePlus: "Dato + dage",
    valueTypeDatabase: "Databasefelt",

    // Field position & size labels
    xMm: "X (mm)",
    yMm: "Y (mm)",
    rotation: "Rotation",

    // Separator & value position
    separator: "Separator",
    separatorHint: "Tekst mellem label og værdi. Lad stå tom for ingen separator.",
    separatorPlaceholder: ": ",
    valueXMm: "Værdi X (mm)",
    valueXHint: "Lad stå tom for at placere efter label",
    valueYMm: "Værdi Y (mm)",
    valueYHint: "Lad stå tom for at bruge label Y",
    valueFontSize: "Værdi skriftstørrelse",
    valueFontSizeHint: "Lad stå tom for at bruge label-størrelse",

    // Font style
    bold: "Fed",
    italic: "Kursiv",

    // Text alignment
    textAlignment: "Tekstjustering",
    alignLeft: "Venstre",
    alignCenter: "Centreret",
    alignRight: "Højre",

    // QR Code
    qrDataSource: "QR-datakilde",

    // Barcode
    barcodeDataSource: "Datakilde",
    barcodeWidthMm: "Stregkodebredde (mm)",
    barcodeHeightMm: "Stregkodehøjde (mm)",
    barcodeDisplayValue: "Vis værdi under stregkode",

    // Allergens text
    allergenSeparator: "Separator",
    allergenSeparatorHint: "Tegn mellem allergennavne (f.eks. ', ' eller ' / ')",

    // Divider
    dividerLineWidth: "Linjebredde (mm)",
    dividerLineWidthHint: "Bredde af skillelinjen",
    dividerLineThickness: "Linjetykkelse (mm)",
    dividerLineThicknessHint: "Tykkelse af linjen",

    // Database Fields
    fridgeValue: "Køleskabsværdi",
    fridgeValueHint: "fx FØR ÅBNING",
    threeHours: "Tre timer (JA/NEJ)",
    itemName: "Produktnavn",
    
    // Offset Fields
    thawingDaysOffset: "Optøningsdage",
    refrigeratedDaysOffset: "Køledage",
    expiryDays: "Holdbarhed (dage)",
    thawingHours: "Optønings timer",
    refrigeratedHours: "Køle timer",
    expiryHours: "Holdbarhed (timer)",
    showTime: "Vis klokkeslet",
    
    // QR Data Fields
    itemId: "Produkt-ID",
    customUrl: "Brugerdefineret URL",
    customData: "Brugerdefineret data",

    // Snackbar / status messages
    labelSavedSuccess: "Etiket gemt",
    labelSaveFailed: "Kunne ikke gemme etiket",
    labelLoadFailed: "Kunne ikke indlæse etiketter",
    labelLoadSingleFailed: "Kunne ikke indlæse etiket",
    fieldOrderUpdated: "Feltrækkefølge opdateret",

    // Labels management view
    labelsDescription: "Administrer dine etiketter — se detaljer, aktiver/deaktiver eller slet.",
    totalLabels: "Etiketter i alt",
    activeLabels: "Aktive etiketter",
    inactiveLabels: "Inaktive etiketter",
    labelsList: "Etiketter",
    searchLabels: "Søg i etiketter...",
    dimensions: "Dimensioner",
    inactive: "Inaktiv",
    color: "Farve",
    type: "Type",
    freetext: "Fritekst",
    viewLabel: "Se etiket",
    noLabelsFound: "Ingen etiketter fundet",
    createFirstLabel: "Opret din første etiket",
    namePosition: "Navn position",
    fieldLabel: "Feltnavn",
    position: "Position",
    noFields: "Ingen felter konfigureret",
    hasLogo: "Logo tilføjet",
    status: "Status",
    editInDesigner: "Rediger i designer",
    confirmDeleteText: "Er du sikker på at du vil slette '{labelName}'? Denne handling kan ikke fortrydes.",
    deleteWarning: "Alle felter tilknyttet denne etiket vil også blive slettet.",
    labelActivated: "'{name}' er nu aktiv",
    labelDeactivated: "'{name}' er nu inaktiv",
    labelToggleError: "Kunne ikke ændre etiket status",
    labelDeleted: "'{name}' er slettet",
    labelDeleteError: "Kunne ikke slette etiket",
    close: "Luk",
    deleteLabel: "Slet etiket",

    // device management
    devicesDescription: "Administrer dine enheder og licenser.",
    totalLicenses: "Licenser i alt",
    usedLicenses: "Brugte licenser",
    availableLicenses: "Ledige licenser",
    devicesList: "Enheder",
    searchDevices: "Søg i enheder...",
    deleteDevice: "Slet enhed",
    noDevicesFound: "Ingen enheder fundet",
    noDevicesHint: "Enheder registreres via appen.",
    deleteDeviceHint: "Enheden skal registreres igen for at kunne bruges.",
    deviceDeleted: "'{name}' er slettet",
    deviceDeleteError: "Kunne ikke slette enhed",
    canEdit: 'Kan redigere',
    cannotEdit: 'Kan ikke redigere',
    canEditProducts: 'Redigering',
    allowEditing: 'Tillad redigering',
    disableEditing: 'Deaktiver redigering',
    editingEnabled: 'Redigering aktiveret',
    editingDisabled: 'Redigering deaktiveret',
    selected: 'valgt',
    updateError: 'Opdatering fejlede',
    canDelete: "Kan slette",
    cannotDelete: "Kan ikke slette",
    canDeleteProducts: "Sletning",
    allowDeleting: "Tillad sletning",
    disableDeleting: "Deaktiver sletning",
    deletingEnabled: "Sletning aktiveret",
    deletingDisabled: "Sletning deaktiveret",
    editingDisabledCascade: 'Redigering deaktiveret — sletning blev også deaktiveret',
    deletingEnabledCascade: 'Sletning aktiveret — redigering blev også aktiveret',
    allowBackdating: "Tillad baguddatering",
    disallowBackdating: "Deaktiver baguddatering",
    backdatingEnabled: "Baguddatering aktiveret",
    backdatingDisabled: "Baguddatering deaktiveret",
    backdatingDisabledCascade: "Baguddatering deaktiveret — redigering blev også deaktiveret",
    backdatingEnabledCascade: "Baguddatering aktiveret — redigering blev også aktiveret",
    backdatingOff: "Baguddatering deaktiveret",
    backdatingOn: "Baguddatering aktiveret",
    maxBackdateDays: "Maksimalt antal dage for baguddatering",
    maxBackdateDaysHint: "Indstil hvor mange dage tilbage i tiden en bruger kan vælge for produceret/åbnet dato. 0 = deaktiver baguddatering.",

    // Configurations Page
    configurations: "Konfigurationer",
    globalSettings: "Globale Indstillinger",
    globalSettingsHint: "Disse indstillinger gælder for alle tablets på denne konto. Gemning opdaterer versionen, så tablets henter nye indstillinger.",
    tabletFields: "Tablet Felter",
    tabletFieldConfig: "Tablet Feltkonfiguration",
    tabletFieldConfigHint: "Konfigurer hvilke felter der er synlige ved oprettelse eller redigering af varer på tablets.",
    tabletFieldConfigInfo: "Træk for at ændre rækkefølge. Skjulte felter vises ikke på tablet-dialoger. Påkrævede felter skal udfyldes inden gemning.",
    freetextLabels: "Fritekst Labels",
    freetextLabelsOverview: "Fritekst Labels",
    freetextLabelsHint: "Alle fritekst labels inklusiv lokale tablet-labels. Lokale labels er kun synlige på den enhed, der oprettede dem.",
    noFreetextLabels: "Ingen fritekst labels fundet.",
    reassignToDevice: "Tildel til enhed",
    reassignHint: "Vælg en enhed for at tildele denne fritekst label. Den vil ikke længere være synlig på den oprindelige enhed.",
    labelsSelected: "{count} label(s) valgt",
    targetDevice: "Enhed for tildeling",
    markAsLocal: "Marker som lokal",
    reassign: "Tildel",
    moveToDevice: "Flyt til enhed",
    removeFromAll: "Fjern fra alle enheder",
    broadcastNewLabel: "Udsend ny label til flere enheder",
    broadcastNew: "Opret ny",
    broadcast: "Udgiv",
    freetextContent: "Fritekst indhold",
    selectAll: "Vælg alle",
    deselectAll: "Fravælg alle",
    selectDevices: "Vælg enheder",
    broadcastDevices: "Send til {count}",
    devicesSelected: "{count} enhed(er) valgt",
    pushToDevices: "Send til {count} enheder",
    pushExistingHint: "Send eksisterende label til flere enheder.",
    activeBroadcasts: "Aktive broadcasts",
    broadcastsHint: "Fritekst labels der i øjeblikket er udsendt til flere enheder. De forbliver aktive indtil de fjernes manuelt fra alle enheder eller tildeles en enkelt enhed.",
    noBroadcasts: "Ingen aktive broadcasts",
    valuesInDays: "dage",
    valuesInHours: "timer",
    showAlias: "Vis Alias",
    showAliasHint: "Vis 'Alias' feltet på tablet-startskærmen under produktnavnet.",
    showMenuTab: "Vis menu fane",
    showMenuTabHint: "Vis aktiv menu som fane på tablet startskærmen",
    hideCategoryAll: "Skjul 'Alle' kategori",
    hideCategoryAllHint: "Skjul 'Alle' kategorien fra kategorimenuen på tablets",

    // Global Settings Toggles
    useCategoriesHint: "Vis kategorimenu på tablets og kategorivalg ved oprettelse af varer",
    usePrintDialog: "Vis Udskrivningsdialog",
    usePrintDialogHint: "Vis dialog med datovalg før labels udskrives på tablets",
    showTimestampOnDates: "Vis Klokkeslæt på Datoer",
    showTimestampOnDatesHint: "Inkluder TT:MM tidsstempel på datolabels (f.eks. 17/02/26 10:30)",
    showCategoryOnProduct: "Vis Kategori på Produkt",
    showCategoryOnProductHint: "Vis kategorinavn under produktnavn på tablet-startskærmen",
    todaysDateInclusive: "Dagens Dato Inkluderet",
    todaysDateInclusiveHint: "Inkluder dags dato i udløbsberegning (f.eks. 3 dage fra mandag = onsdag i stedet for torsdag)",
    settingsVersionInfo: "Aktuel version",
    settingsVersionHint: "Tablets med en ældre version henter opdaterede indstillinger ved næste opdatering.",
    saveChanges: "Gem Ændringer",

    // Field Config Table
    fieldName: "Felt",
    customLabel: "Brugerdefineret Label",
    visible: "Synlig",
    required: "Påkrævet",

    // Freetext Table
    content: "Indhold",
    device: "Enhed",
    scope: "Omfang",
    updated: "Opdateret",
    local: "Lokal",
    global: "Global",
    confirmDeleteFreetext: "Er du sikker på, at du vil slette dette fritekst label?",
    freetextSizes: "Tilgængelige størrelser",
    freetextSizesHint: "Liste over tilgængelige fritekst størrelser.",
    createSize: "Opret størrelse",
    createFreetextSize: "Opret fritekst størrelse",
    widthMm: "Bredde (mm)",
    heightMm: "Højde (mm)",
    freetextSizeWhiteHint: "Fritekst labels vises som hvide",
    default: "Standard",
    setAsDefault: "Sæt som standard",
    cancelDefault: "Annuller standard",

    // Location management
    locationName: "Lokationsnavn",
    assignUser: "Tildel bruger",
    assignedUsers: "Tildelte brugere",
    noUsersAssigned: "Ingen brugere tildelt",
    addUsers: "Tilføj brugere",
    selectUsers: "Vælg brugere",
    assignProducts: "Tildel produkter",
    assignedProducts: "Tildelte produkter",
    availableProducts: "Tilgængelige produkter",
    noProductsAssigned: "Ingen produkter tildelt",
    allProductsAssigned: "Alle produkter tildelt",
    countryCode: "Landekode",
    timezone: "Tidszone",
    createdLocation: "Lokation oprettet",
    editLocation: "Rediger lokation",
    totalLabelsPrinted: "Totalt antal etiketter printet",
    clickForBreakdown: "Klik for en detaljeret opgørelse",
    printStatsTitle: "Udskriftsstatistik",
    noPrintEvents: "Ingen udskriftsstatistik fundet for lokationer",
    labelsPrintedTotal: 'etiketter printet i alt',
    since: 'siden',
    createLocation: "Opret lokation",

    //Tickets System
    createTicket: "Opret Ticket",
    ticketType: "Ticket Type",
    ticketTypeSale: "Salg",
    ticketTypeSupport: "Support",
    ticketTypeBug: "Fejlrapport",
    ticketTitle: "Titel",
    ticketDescriptionHint: "Beskriv dit problem eller forespørgsel i detaljer",
    ticketReporter: "Rapportør",
    ticketCreated: "Ticket oprettet",
    priority: "Prioritet",
    priorityHint: "Undlad at udfylde og lad systemet bestemme baseret på ticketens indhold, eller vælg manuelt",
    priorityAuto: "Auto",
    priorityLow: "Lav",
    priorityMedium: "Mellem",
    priorityHigh: "Høj",
    priorityUrgent: "Urgent",
    submit: "Indsend Ticket",
    tickets: "Tickets",
    orderAccessories: "Bestil labels & tilbehør",
    ticketLogHint: "Liste over support-henvendelser sendt til Capture IT.",

    impersonation: {
        menuItem: "Gå ind som kunde",
        title: "Gå ind som kunde",
        subtitle: "Vælg en kunde for at arbejde i deres konto. Alt hvad du gør, sker på deres rigtige data.",
        search: "Søg efter kunde, kontonummer eller e-mail...",
        customer: "Kunde",
        lastPrint: "Sidst printet",
        enter: "Gå ind",
        noCustomers: "Ingen kunder fundet",
        loadFailed: "Kunne ikke hente kundelisten",
        confirmTitle: "Gå ind som kunde?",
        confirmText: "Du er ved at åbne {customer}s konto med deres egen administrators rettigheder.",
        confirmWarning: "Alt du foretager dig, sker på kundens rigtige data. Sessionen logges og udløber automatisk efter 2 timer.",
        bannerTitle: "Du arbejder i {customer}s konto",
        bannerSubtitle: "Logget ind som dig selv ({user}) bagved",
        stop: "Afslut",
        actions: "Handlinger",
    },

    designer: {
        untitled: "Uden titel",
        noLabel: "Ingen etiket valgt",
        saved: "Gemt",
        saveError: "Kunne ikke gemme",
        unsavedTitle: "Ugemte ændringer",
        unsavedConfirm: "Du har ugemte ændringer. Vil du forlade siden?",
        leaveAnyway: "Forlad alligevel",
        stay: "Bliv",
        toggleGrid: "Skift gitter",
        preview: "Forhåndsvisning",
        undo: "Fortryd",
        redo: "Gentag",
        save: "Gem",
        print: "Udskriv",
        back: "Tilbage",
    },
    fields: {
        productFields: "Produktfelter",
        productField: "Produkt felt",
        barcodes: "Stregkoder",
        layout: "Layout",
        qrCode: "QR-kode",
        staticText: "Statisk tekst",
        imageLogo: "Logo billede",
        divider: "Skillelinje",
        productNumber: "Produktnummer",
        productName: "Produktnavn",
        description: "Beskrivelse",
        costPrice: "Kostpris",
        salesPrice: "Salgspris",
        currency: "Valuta",
    },
    common: {
        none: "Ingen",
        save: "Gem",
        cancel: "Annuller",
        delete: "Slet",
        close: "Luk",
        edit: "Rediger",
        copy: "Kopier",
        unsaved: "Ugemte ændringer",
        loading: "Indlæser...",
        error: "Fejl",
        success: "Succes",
    },
    label: {
        name: "Etiketnavn",
        width: "Bredde (mm)",
        height: "Højde (mm)",
        color: "Farve",
        colour: "Farve",
        type: "Type",
        grid: "Gitter",
        gridSize: "Gitterstørrelse (mm)",
        active: "Aktiv",
        unit: "Enhed",
        mm: "mm",
        inch: "tomme",
    },
    canvas: {
        grid: "Vis gitter",
        gridSize: "Gitterstørrelse (mm)",
        layers: "Lag",
        noElements: "Ingen elementer",
    },
    importFromOld: "Importér fra gammelt system",
    selectLabelsToImport: "Vælg etiketter at importere",
    importHint: "Etiketter importeres til det nye system. Det originale beholdes.",
    importCount: "Importér {n} etiket(ter)",
    newDesign: "Ny etiket",
    designs: "Etiketter",
    searchDesigns: "Søg i etiketter...",
    totalDesigns: "Etiketter i alt",
    activeDesigns: "Aktive etiketter",
    inactiveDesigns: "Inaktive etiketter",
    designCreated: "Etiket oprettet",
    designCopied: "Etiket kopieret",
    designDeleted: "Etiket slettet",
    designsDeleted: "Etiketter slettet",
    deleteDesign: "Slet etiket",
    deleteDesignConfirm: "Er du sikker på at du vil slette '{name}'?",
    bulkDelete: "Slet valgte",
    bulkDeleteConfirm: "Er du sikker på at du vil slette {n} etiketter?",
    errorCreating: "Kunne ikke oprette etiket",
    errorUpdating: "Kunne ikke opdatere etiket",
    errorCopying: "Kunne ikke kopiere etiket",
    errorDeleting: "Kunne ikke slette etiket",
    errorLoading: "Kunne ikke indlæse etiketter",
    importSuccess: "{n} etiket(ter) importeret",
    importError: "Fejl ved import",
    labelsSubtitle: "Administrer dine etiketter",
    roundExpiryDownToQuarter: "Rund udløbsdato ned til nærmeste kvarter",
    roundExpiryDownToQuarterHint: "Kun ved holdbarhed i timer. Et udløb kl. 16:07 vises som 16:00 — altid ned, så holdbarheden aldrig overskrides",
    // Shown on the colour swatch in the product list when the
    // product prints with something other than its own label.
    labelInactiveFallback: "Etiketten \"{label}\" er inaktiv — printer med \"{fallback}\"",
    labelMissingFallback: "Ingen etiket valgt — printer med \"{fallback}\"",

    // Bulk deletion of categories, including the "these still
    // contain products — move them where?" second step.
    confirmBulkDeleteCategories: "Slet de valgte kategorier?",
    bulkDeleteWarning: "Handlingen kan ikke fortrydes.",
    categoriesInUseTitle: "Kategorierne er i brug",
    categoriesInUseText: "Følgende kategorier indeholder stadig varer:",
    moveProductsTo: "Flyt varerne til",
    moveAndDelete: "Flyt og slet",
    noReassignTarget: "Alle kategorier er valgt. Fravælg mindst én at flytte varerne til.",
    categoriesDeleted: "kategorier slettet",
    productsMoved: "varer flyttet",
    defaultCategorySkipped: "standardkategorien blev sprunget over",
    bulkDeleteFailed: "Sletningen fejlede",

    totalLocations: "Lokationer i alt",

    productImage: "Produktbillede",
    chooseFromLibrary: "Vælg fra bibliotek",
    changeImage: "Skift billede",
    productImageHint: "Vises på tablet i stedet for produktnavnet, hvis billedvisning er slået til",
    productImageLibrary: "Billedbibliotek",

    productImages: {
        libraryTitle: "Billedbibliotek",
        libraryHint: "Upload alle produktbilleder på én gang og vælg dem ind på varerne bagefter.",
        uploadButton: "Upload billeder",
        deleteSelected: "Slet valgte",
        uploadProgress: "Uploader",
        alreadyInLibrary: "Findes allerede i biblioteket",
        noImages: "Ingen billeder endnu",
        preview: "Forhåndsvisning",
        name: "Navn",
        dimensions: "Mål",
        usedBy: "Bruges af",
        uploaded: "Uploadet",
        uploadSummary: "{n} billeder uploadet",
        uploadSummaryFailed: "{n} uploadet, {failed} fejlede",
        uploadSummaryDuplicates: "{n} uploadet, {duplicates} sprunget over som dubletter",
        imageRenamed: "Billede omdøbt",
        renameFailed: "Kunne ikke omdøbe billedet",
        confirmDeleteImage: "Er du sikker på at du vil slette dette billede?",
        deleteImageInUseWarning: "{n} varer bruger dette billede og mister det.",
        imageDeleted: "Billede slettet",
        imageDeletedInUse: "Billede slettet — de varer der brugte det, har nu intet billede",
        deleteFailed: "Kunne ikke slette billedet",
        confirmBulkDelete: "Bekræft sletning",
        confirmBulkDeleteText: "Er du sikker på at du vil slette {n} billeder?",
        selectedInUseWarning: "{n} af de valgte billeder er i brug og mistes på de varer der bruger dem.",
        andMoreCount: "… og {n} flere",
        deleteAll: "Slet alle",
        imagesDeletedSummary: "{n} billeder slettet",
        imagesDeletedMissing: "{n} billeder slettet ({missing} fandtes ikke)",
        bulkDeleteFailed: "Kunne ikke slette billederne",

        picker: {
            title: "Vælg billede",
            uploadNew: "Upload nye",
            search: "Søg i billeder...",
            empty: "Der er ingen billeder i biblioteket endnu. Upload nogle for at komme i gang.",
            noMatch: "Ingen billeder matcher søgningen",
            removeImage: "Fjern billede",
            uploadFailedCount: "{n} billeder kunne ikke uploades",
        },
    },
    showProductImages: "Vis produktbilleder",
    showProductImagesHint: "Vis produktbilleder på tablet-startskærmen.",
    showProductNames: "Vis produktnavne",
    showProductNamesHint: "Vis produktnavne på tablet-startskærmen.",

    productDisplayMode: "Produktvisning",
    displayModeText: "Navne",
    displayModeImage: "Billeder",
    displayModeUser: "Brugerens valg",
    mixed: "Blandet",
    noDevicesUpdated: "Ingen enheder blev opdateret",
    customFields: "Tilpassede felter",
    customFieldsHint: "Tilpas felter til at vise specifikke produktoplysninger",
    noCustomFields: "Ingen tilpassede felter",
    editField: "Rediger felt",
    fieldLabelHint: "Etiket for feltet",
    fieldPrefixHint: "Præfiks for feltet",
    fieldKeyFixedHint: "Nøgle for feltet (kan ikke ændres)",
    deleteFields: "Slet felter",
    deleteFieldsWarning: "Dette vil slette de valgte felter permanent",
    deactivateInsteadHint: "Deaktiver i stedet for at slette",
    fieldsDeleted: "Felter slettet",
    valuesRemoved: "Værdier fjernet",
    storedValues: "Gemte værdier",
    printedPrefix: "Udskrevet præfiks",
    prefix: "Præfiks",
    fieldKey: "Felt nøgle",
    values: "Værdier",
    sortOrder: "Sorteringsrækkefølge",
    labelRequired: "Etiket er påkrævet",

    ...designerI18n.da,
}